import moment from 'moment';

let date_from = moment().add(5, 'day').format('DD.MM.YYYY');
let date_to = moment().add(16, 'day').format('DD.MM.YYYY');

const requestModel = {
  adults: 2,
  ages: [],
  cities: [],
  country: 4,
  currency: 0,
  custom_country: [1, 2, 3, 4, 6, 9, 14, 18, 16, 20, 33],
  custom_type: false,
  datefrom: date_from,
  dateto: date_to,
  departure: 1,
  hotel_rating: 0,
  hotel_type: null,
  hotels: [],
  child: 0,
  mealbetter: 1,
  meal: 0,
  nightsfrom: 6,
  nightsto: 14,
  operators: [],
  pricefrom: '',
  priceto: '',
  promo: 0,
  provider: 'tourvisor',
  races: 1,
  hideregular: 1,
  recomend: false,
  services: [],
  stars: 1,
  regions: [],
  subregions: [],
  hideoperator: false,
  actypes: [],
};
console.log('request_model');

export default requestModel;

// const geograftour__json = {
//   LANGUAGE_CODE: '{{ LANGUAGE_CODE }}',
//   CABINET_HOST: '{{ CABINET_HOST }}',
//   CACHE_GEO_REGIONS: '{{ global_cache_dict.geo_regions }}',
//   COUNTRY_CURRENCY: {{ country_currency }},
//   DEPART_REPLACE: {{ depart.depart_replace_json|jsonify }},
//   DEPART_DATA: {{ depart.to_json }},

//   /**
//    * в tour_data  упаковывать из модели Page все поля которые относятся
//    * к назначаемым параметрам тура например  tour_price_lower, tour_stars, tour_*
//    *
//    */
//   tour_data: {
//     START_DATE: {{ start_date|date:"d/m/Y" }},
//     END_DATE: {{ end_date|date:"d/m/Y" }},
//     PRICE_TO: {{ request.page.tour_price_top }},
//     HIDE_REGULAR: {{ request.page.tour_is_charter }},
//     COUNTRY_DATA: {{ country }},
//     TOUROPERATORS: {{ oper }},
//     REGIONS: {{ cities }},
//     SUBREGION: {{ subregions }},
//     HOTELS: {{ hotels }},
//     MEAL: = {{ meal }},
//     STARS: = {{ stars }},
//     ADULT: = {{ adult}},
//     CHILD: = {{child}},
//     HOTEL_CUSTOM_TYPE: = {{ hotel_type }},
//     SERVICE: = {{ service }},
//     MIN_NIGTHS: = {{ nightsfrom }},
//     MAX_NIGTHS: = {{ nightsto }},
//   },

//   TOURS_REQUEST: = {{ request.page.tours_json }}, // список запросов по различным параметрам стран, городов вылета, даты
//   PAGE_IS_CREDIT: {{ page.is_credit }},
//   HAS_FLAT_TOURS = {{ tours_from_cache }},

// }

// departure – код города вылета
// country – код страны
// datefrom - дата от в формате дд.мм.гггг (если не указан - текущая дата +1 день)
// dateto - дата до в формате дд.мм.гггг (если не указан - текущая дата +8 дней). Максимальный диапазон = 2 недели (14 дней)
// nightsfrom - ночей от (по умолчанию = 7)
// nightsto - ночей до (по умолчанию = 10)
// adults - кол-во взрослых (по умолчанию = 2)
// child - кол-во детей (по умолчанию = 0)
// childage1 - возраст 1 ребенка, лет (опционально). Младенец = 1.
// childage2 - возраст 2 ребенка, лет (опционально). Младенец = 1.
// childage3 - возраст 3 ребенка, лет (опционально). Младенец = 1.
// stars – категория отеля (звездность) (опционально)
// starsbetter – 1 – показывать категории лучше указанной. по умолчанию 1 (опционально)
// meal - тип питания (код) (опционально)
// mealbetter – 1 – показывать питание лучше указанного. по умолчанию 1 (опционально)
// rating – рейтинг отеля (опционально). Используется кодировка: 0: любой, 2: >= 3.0, 3: >= 3.5, 4: >= 4.0, 5: >= 4.5  (т.е. нужно передать целое число, соотв. критерию)
// hotels - коды отелей (если несколько, то через запятую) (опционально)
// hoteltypes - типы отелей (через запятую: active, relax, family, health, city, beach, deluxe) пример:relax,beach  (опционально).
// pricetype - тип цены. 0 – цена за номер, 1 – цена за человека (по умолчанию 0)
// regions – коды курортов (если несколько, то через запятую) (опционально)
// subregions – коды вложенных курортов (районов) (если несколько, то через запятую) (опционально). Если Вам нужен поиск по конкретному району (subregion), то соответствующий ему параметр regions указывать не нужно, иначе будет производиться поиск по всему курорту (region), который Вы указали.
// operators - список операторов (через запятую) (опционально)
// pricefrom - цена от (в рублях, опционально)
// priceto - цена до (в рублях, опционально)
// currency – валюта, в которой производить выдачу результатов поиска. 0 = рубли (по-умолчанию), 1 – у.е. (USD или EUR, зависит от страны), 2 – бел.рубли, 3 – тенге
// hideregular = 1 - скрыть туры на регулярных рейсах
// services - список услуг в отеле, через запятую, опционально
